import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { useTranslation } from 'react-i18next';

const EntitySelector = ({
  entityType,
  entities = [],
  selectedEntity,
  onEntitySelect,
  disabled = false,
  disableCreate = false,
}) => {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const [mode, setMode] = useState('select');
  const [searchTerm, setSearchTerm] = useState('');
  const [newEntityName, setNewEntityName] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [filteredEntities, setFilteredEntities] = useState(entities);

  useEffect(() => {
    if (mode === 'select') {
      const filtered = entities.filter((entity) => entity.name.toLowerCase().includes(searchTerm.toLowerCase()));
      setFilteredEntities(filtered);
    }
  }, [entities, searchTerm, mode]);

  const handleModeSwitch = (newMode) => {
    onEntitySelect(null);
    setMode(newMode);
    setNewEntityName('');
    setSearchTerm('');
    setIsOpen(false);
  };

  const handleEntitySelect = (entity) => {
    onEntitySelect(entity);
    setIsOpen(false);
  };

  const handleEntityCreate = (e) => {
    const val = e.target.value;
    setNewEntityName(val);
    onEntitySelect(val);
  };

  return (
    <div className={styles.entitySelector}>
      <div className={styles.entityHeader}>
        <label className={styles.entityLabel}>{entityType}</label>
        {disableCreate ? (
          <div></div>
        ) : (
          <div className={styles.modeToggle}>
            <button
              onClick={() => handleModeSwitch('select')}
              className={`${styles.toggleBtn} ${mode === 'select' ? styles.active : ''}`}
            >
              {tCommon('Select Existing')}
            </button>
            <button
              onClick={() => handleModeSwitch('create')}
              className={`${styles.toggleBtn} ${mode === 'create' ? styles.active : ''}`}
            >
              {tCommon('Create New')}
            </button>
          </div>
        )}
      </div>

      {mode === 'select' && (
        <div className={styles.selectWrapper}>
          <div onClick={() => setIsOpen(!isOpen)} className={styles.selectDisplay}>
            <span className={selectedEntity ? styles.selected : styles.placeholder}>
              {selectedEntity ? selectedEntity?.name : tCommon('Select {{entityType}}', { entityType })}
            </span>
            <ExpandMoreRoundedIcon className={`${styles.icon} ${isOpen ? styles.rotated : ''}`} />
          </div>

          {isOpen && (
            <div className={styles.dropdown}>
              <div className={styles.searchBox}>
                <SearchRoundedIcon className={styles.searchIcon} />
                <input
                  type="text"
                  disabled={disabled}
                  placeholder={tCommon('Search {{entityType}}...', { entityType })}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              <div className={styles.options}>
                {filteredEntities.length > 0 ? (
                  filteredEntities.map((entity) => (
                    <button key={entity.id} onClick={() => handleEntitySelect(entity)} className={styles.optionBtn}>
                      <span>{entity.name}</span>
                      {selectedEntity?.id === entity.id && <CheckRoundedIcon className={styles.checkIcon} />}
                    </button>
                  ))
                ) : (
                  <div className={styles.emptyState}>
                    <SearchRoundedIcon className={styles.emptyIcon} />
                    <p>{tPopup('No {{entityType}} found', { entityType })}</p>
                    <button onClick={() => handleModeSwitch('create')} className={styles.createLink}>
                      {tPopup('Create new {{entityType}} instead', { entityType })}
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {mode === 'create' && (
        <div className={styles.createSection}>
          <div className={styles.inputWrapper}>
            <input
              type="text"
              disabled={disabled}
              placeholder={tCommon('Enter {{entityType}} name', { entityType })}
              value={newEntityName}
              onChange={(e) => handleEntityCreate(e)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EntitySelector;
